var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-marketplace" }, [
    _c(
      "div",
      { staticClass: "filters-section" },
      [
        _c("a-input-search", {
          staticStyle: { width: "300px" },
          attrs: {
            placeholder: _vm.$t("chatbotv2.searchBlocks") || "Search blocks...",
          },
          on: { search: _vm.handleSearch },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        }),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "200px" },
            attrs: {
              placeholder: _vm.$t("chatbotv2.category") || "Category",
              allowClear: "",
            },
            on: { change: _vm.handleSearch },
            model: {
              value: _vm.selectedCategory,
              callback: function ($$v) {
                _vm.selectedCategory = $$v
              },
              expression: "selectedCategory",
            },
          },
          _vm._l(_vm.categoryOptions, function (category) {
            return _c(
              "a-select-option",
              { key: category.value, attrs: { value: category.value } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(category.label) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "200px" },
            on: { change: _vm.handleSearch },
            model: {
              value: _vm.sortBy,
              callback: function ($$v) {
                _vm.sortBy = $$v
              },
              expression: "sortBy",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "usageCount" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.mostUsed") || "Most Used")),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "rating" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.topRated") || "Top Rated")),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "newest" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.newest") || "Newest")),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "name" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.name") || "Name")),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "blocks-grid" },
          _vm._l(_vm.blocks, function (block) {
            return _c(
              "div",
              {
                key: block._id,
                staticClass: "block-card",
                on: {
                  click: function ($event) {
                    return _vm.viewBlockDetails(block._id)
                  },
                },
              },
              [
                _c("div", { staticClass: "block-header" }, [
                  _c(
                    "span",
                    {
                      staticClass: "material-icons block-icon",
                      style: { color: _vm.getBlockColor(block) },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(block.icon || "extension") +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "block-title-section" }, [
                    _c("h3", [_vm._v(_vm._s(block.name))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-meta" }, [
                      _c("span", { staticClass: "category-tag" }, [
                        _vm._v(_vm._s(block.category)),
                      ]),
                      _vm._v(" "),
                      block.averageRating > 0
                        ? _c(
                            "span",
                            { staticClass: "rating" },
                            [
                              _c("a-icon", {
                                attrs: { type: "star", theme: "filled" },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(block.averageRating.toFixed(1)) +
                                  "\n                        "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "block-description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        block.description || _vm.$t("chatbotv2.noDescription")
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "block-footer" },
                  [
                    _c(
                      "div",
                      { staticClass: "usage-count" },
                      [
                        _c("a-icon", { attrs: { type: "download" } }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(block.usageCount || 0) +
                            " " +
                            _vm._s(_vm.$t("chatbotv2.uses")) +
                            "\n                "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isImported(block._id)
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.importBlock(block._id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("chatbotv2.import")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _c("a-tag", { attrs: { color: "green" } }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("chatbotv2.imported")) +
                              "\n                "
                          ),
                        ]),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "loading-state" },
          [_c("a-spin", { attrs: { size: "large" } })],
          1
        ),
    _vm._v(" "),
    !_vm.loading && _vm.blocks.length === 0
      ? _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("a-empty", {
              attrs: { description: _vm.$t("chatbotv2.noBlocksFound") },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }